export const SCHEMA_VERSION = '1.11.0';
